import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";

import hangingFlowerBaskets from "../../../assets/img/indoor-tropical-plants-greenhouse-vancouver.jpg";
import bloomingHydrangea from "../../../assets/img/blooming-hydrangea-flowers-vancouver.jpg";
import cactusSucculent from "../../../assets/img/cactus-succulent-plants-vancouver-garden-center.jpg";

export default function DykhofNurseriesBlog() {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle =
      "Dykhof Nurseries: A North Vancouver Legacy Since 1957 - BUR-HAN";
    document.title = newTitle;

    const newDescription =
      "Discover the legacy of Dykhof Nurseries in North Vancouver and how BUR-HAN Garden & Lawn Care helps bring their premium plants to life with expert landscaping services.";
    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "Dykhof Nurseries North Vancouver, local nursery North Van, BUR-HAN landscaping partnership, premium plants North Vancouver, expert garden center, sustainable gardening, family-owned nurseries Vancouver",
    ].join(", ");

    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost dykhof">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                Dykhof Nurseries: Growing with North Vancouver
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                Since 1957 — In Partnership with BUR-HAN
              </div>
            </h1>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              For over 65 years, Dykhof Nurseries has been a cornerstone for
              gardeners in North Vancouver. Their family-run business has
              supplied generations with quality plants, trees, and expert
              gardening advice. At BUR-HAN Garden & Lawn Care, we're proud to
              partner with Dykhof—taking the plants you select from their
              nursery and transforming them into stunning, lasting landscapes.{" "}
            </p>
            <p>
              Founded by Hein Dykhof in 1957, and now on the 4th generation of
              family, the nursery began with cut flowers and soon expanded to
              bedding plants, shrubs, and trees. Over the decades, Dykhof grew
              into a full-service garden center, now located on Old Dollarton
              Road, continuing their tradition of quality and community.{" "}
            </p>

            <img loading="lazy"
              src={hangingFlowerBaskets}
              alt="Assortment of vibrant hanging flower baskets in a sunny greenhouse in Vancouver"
              title="Colorful Hanging Flower Baskets at Vancouver Greenhouse"
              className="imgblog"
            />
            <h2>Why Shop at Dykhof Nurseries?</h2>
            <p>
              Choosing Dykhof means more than just buying plants—you're
              investing in quality, expertise, and community values. Some key
              benefits include:
            </p>
            <ul>
              <li>
                <strong>🌱 Wide Variety of Plants - </strong> From vibrant
                annuals to hardy perennials, shrubs, and mature trees, you'll
                find everything you need in one place.
              </li>
              <li>
                <strong>🌿 Expert Advice - </strong> Their knowledgeable staff
                provides guidance tailored to your garden's conditions, ensuring
                you pick the right plants for long-term success.
              </li>
              <li>
                <strong>🌸 Quality You Can Trust - </strong> Generations of
                experience mean you're getting plants grown with care, backed by
                a reputation for excellence.
              </li>
              <li>
                <strong>🏡 Local Roots - </strong> As a family-owned business
                deeply tied to North Vancouver, they support the local community
                and understand the unique growing conditions of the region.
              </li>
              <li>
                <strong>🌍 Sustainable Practices - </strong> Many of their
                selections are chosen with sustainability and local ecology in
                mind, helping your garden thrive responsibly.
              </li>
            </ul>

            <img loading="lazy"
              src={cactusSucculent}
              alt="Variety of cactus and succulent plants in small pots at a garden center in Vancouver"
              title="Cactus and Succulent Plant Display in Vancouver Garden Center"
              className="imgblog"
            />

            <h2>BUR-HAN Makes the Vision Come to Life</h2>
            <p>
              Shopping at Dykhof is just the beginning. Once you've selected
              your plants, BUR-HAN can take over and ensure your garden or
              landscape flourishes:
            </p>
            <ul>
              <li>
                Professionally plant trees, shrubs, and perennials for optimal
                growth.
              </li>
              <li>
                Install efficient irrigation systems to keep your new plants
                healthy.
              </li>
              <li>Provide lawn care programs to keep surrounding turf lush.</li>
              <li>
                Handle hedge and shrub pruning to maintain shape and health.
              </li>
              <li>
                Offer seasonal cleanups so your garden stays beautiful
                year-round.
              </li>
            </ul>

            <img loading="lazy"
              src={bloomingHydrangea}
              alt="Close-up view of blooming purple, blue, and pink hydrangeas in a garden center"
              title="Colorful Hydrangea Flowers in Full Bloom"
              className="imgblog"
            />
            <p>
              By starting with the high-quality selection at Dykhof and relying
              on BUR-HAN's professional landscaping services, you get the best
              of both worlds: premium plants and expert installation. This
              ensures your investment thrives for years to come.
            </p>

            <p>
              Whether you're starting a new garden, renovating your yard, or
              adding a few statement plants, contact BUR-HAN Garden & Lawn Care
              after your trip to Dykhof. We'll make sure your vision becomes a
              reality—beautifully, efficiently, and built to last.
            </p>

            <p>
              Let BUR-HAN handle the planting, irrigation, and maintenance so
              your new garden thrives season after season.{" "}
              <a
                href="/contact-us"
                style={{ textDecoration: "none", color: "var(--yellow-color)" }}
              >
                Contact us today
              </a>{" "}
              to get started.
            </p>
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/spring-garden-cleanup-guide-for-greater-vancouver">Spring Garden Cleanup Guide for Greater Vancouver</a></li>
            <li><a href="/blog/the-secret-to-a-flourishing-flower-garden">The Secret To A Flourishing Flower Garden</a></li>
            <li><a href="/blog/creating-a-pollinator-and-native-plant-garden">Creating a Pollinator and Native Plant Garden</a></li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}
